'use client';

import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { UnauthQueryOptions } from '@/api';
import type { FilterOption } from '../../constants';
import { FilterCheckboxList } from '../FilterCheckboxList';
import { FilterChipGroup } from '../FilterChipGroup';
import { FilterDrawerShell } from '../FilterDrawerShell';
import { FilterSection } from '../FilterSection';
import { FilterSidebarShell } from '../FilterSidebarShell';
interface DonationFilterProps {
  isDrawerOpen: boolean;
  onCloseDrawer: () => void;
  onApplyDrawer: () => void;
  institutionIds: number[];
  onToggleInstitution: (id: number) => void;
  onReset: () => void;
}
export function DonationFilter(t0) {
  const $ = _c(26);
  const {
    isDrawerOpen,
    onCloseDrawer,
    onApplyDrawer,
    institutionIds,
    onToggleInstitution,
    onReset
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      ...UnauthQueryOptions["get:/wello/v2/allows/home/institution/for-search-filter"]({
        query: {
          institutionFilterType: "BUSINESS"
        }
      }),
      staleTime: Infinity,
      gcTime: Infinity,
      select: _temp3
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    data: t2,
    isLoading: isInstitutionLoading
  } = useQuery(t1);
  let t3;
  if ($[1] !== t2) {
    t3 = t2 === undefined ? [] : t2;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const institutionOptions = t3;
  let t4;
  if ($[3] !== institutionIds || $[4] !== institutionOptions || $[5] !== isInstitutionLoading || $[6] !== onToggleInstitution) {
    t4 = <FilterSection title={"\uC9C0\uC790\uCCB4"}><FilterCheckboxList options={institutionOptions} selectedValues={institutionIds} onToggle={onToggleInstitution} isLoading={isInstitutionLoading} skeletonCount={12} /></FilterSection>;
    $[3] = institutionIds;
    $[4] = institutionOptions;
    $[5] = isInstitutionLoading;
    $[6] = onToggleInstitution;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== onReset || $[9] !== t4) {
    t5 = <FilterSidebarShell onReset={onReset}>{t4}</FilterSidebarShell>;
    $[8] = onReset;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <h3 className="font-700 text-Gray-900 typo-body4">지자체</h3>;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== institutionIds || $[13] !== institutionOptions || $[14] !== isInstitutionLoading || $[15] !== onToggleInstitution) {
    t7 = <div className="flex flex-col gap-12">{t6}<FilterChipGroup options={institutionOptions} selectedValues={institutionIds} onToggle={onToggleInstitution} isLoading={isInstitutionLoading} skeletonCount={12} /></div>;
    $[12] = institutionIds;
    $[13] = institutionOptions;
    $[14] = isInstitutionLoading;
    $[15] = onToggleInstitution;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] !== isDrawerOpen || $[18] !== onApplyDrawer || $[19] !== onCloseDrawer || $[20] !== onReset || $[21] !== t7) {
    t8 = <FilterDrawerShell isOpen={isDrawerOpen} onReset={onReset} onApply={onApplyDrawer} onClose={onCloseDrawer}>{t7}</FilterDrawerShell>;
    $[17] = isDrawerOpen;
    $[18] = onApplyDrawer;
    $[19] = onCloseDrawer;
    $[20] = onReset;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== t5 || $[24] !== t8) {
    t9 = <>{t5}{t8}</>;
    $[23] = t5;
    $[24] = t8;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  return t9;
}
function _temp3(t0) {
  const {
    context
  } = t0;
  return (context?.contents ?? []).filter(_temp).map(_temp2);
}
function _temp2(item_0) {
  return {
    value: item_0.institutionId,
    label: item_0.institutionShortName
  };
}
function _temp(item) {
  return Boolean(item.institutionName);
}